/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 12:21 PM
 *
 */

import React from 'react';
import omit from 'lodash/omit';
import { WarningOctagon } from 'phosphor-react';
import { Member } from 'types/MemberTypes';

import { TableView } from 'components/Table';
import PatientMedicalHistoryModal from 'features/members/components/modal/PatientMedicalHistoryAddEditModal';

interface IProfileTestSection {
  selectedMember: Member;
}

const MedicalHistoryTab = ({ selectedMember }: IProfileTestSection) => {
  return (
    <div className="relative flex w-full flex-col rounded-2xl bg-white p-8 shadow-sm">
      <div className="space-y-8 print:hidden">
        <div className="flex items-center justify-between">
          <div className="print:hidden">
            <h1 className="text-3xl font-medium tracking-wider text-gray-900 sm:text-2xl">
              Patient Medical History
            </h1>
            <h1 className="text-lg font-medium text-gray-500 print:hidden">
              Medical History of Patient taken from Sunya Health Apps
            </h1>
          </div>
          <PatientMedicalHistoryModal selectedMember={selectedMember} />
        </div>

        {selectedMember.medical_history.length !== 0 ? (
          <TableView
            loading={false}
            data={selectedMember.medical_history.map((element) =>
              omit(element, ['id', 'detail_category_id'])
            )}
          />
        ) : (
          <div className="flex  items-center space-x-2 text-xl font-medium text-error-500 ">
            <WarningOctagon size={24} /> <span>No Patient Medical Details Found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MedicalHistoryTab;
